import { useNavigate } from 'react-router-dom';
import TimeFilters from '../../../../components/time-filters';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { apiService } from '../../../../services/api.service';
import { AppStore } from '../../../../store/store';
import { UserState } from '../../../../store/user.slice';
import StatisticSection from '../../../../components/statistics-section';
import StatisticsSectionBarChartType from '../../../../components/statistics-section.bar-chart-type';
import StatisticsSectionChartType from '../../../../components/statistics-section.chart-type';
import { colorsPalette } from '../../../../utils/colors-utils';
import { LabelValue } from '../../../../types/label-value.types';
import AppSelect from '../../../../components/form/base/app-select';
import './reports-processor-page.scss';
import { getColorByStatusType, getColorByCardBrandType, transformTransactionsToChartLineData, transformCardBrandToChartLineData, transformToChartLineData } from '../../../../utils/constants';
import { StatisticLineChartData } from '../../../../types/statistics.types';
import StatisticsSectionLineChart from '../../../../components/statistics-section.line-chart';


const ReportsProcessorPage: React.FC = () => {
    const navigate = useNavigate();
    const [startDate, setStartDate] = useState<string>();
    const [endDate, setEndDate] = useState<string>();

    const [transactionsStatus, setTransactionsStatus] = useState();
    const [statusLoader, setStatusLoader] = useState(false);
    const [transactionsChartStatus, setTransactionsChartStatus] = useState<StatisticLineChartData[]>();
    const [transactionsChartLoader, setTransactionsChartLoader] = useState(false);

    const [cardTypes, setCardTypes] = useState([]);
    const [cardsLoader, setCardsLoader] = useState(false);
    const [cardChartTypes, setCardChartTypes] = useState<StatisticLineChartData[]>();
    const [cardChartLoader, setCardChartLoader] = useState(false);

    const [merchants, setMerchants] = useState();
    const [merchantsLoader, setMerchantsLoader] = useState(false);
    const [merchantsChart, setMerchantsChart] = useState<StatisticLineChartData[]>();
    const [merchantsChartLoader, setMerchantsChartLoader] = useState(false);

    const [transactionsNumber, setTransactionsNumber] = useState();
    const [processorsOptions, setProcessorsOptions] = useState<LabelValue[]>([]);
    const [selectedProcessor, setSelectedProcessor] = useState<string>();
    const { user } = useSelector<AppStore, UserState>((state) => state.user)

    const isMerchant = (user?.roles?.includes("merchant") || user?.roles?.includes("bas_merchant_view")) ?? false;



    useEffect(() => {

        apiService
            .getAllProcessors()
            .then((response) => {
                const transformedProcessors = response.data.map((processor: any) => ({
                    label: processor.processorName || processor.processorType || 'Unknown',
                    value: processor.id,
                }));
                setProcessorsOptions([{
                    label: 'Reset',
                    value: '',
                }, ...transformedProcessors]);
            })
            .catch((error) => console.error('Error fetching merchants:', error));

        apiService.getTransactionsSummary({ startDate, endDate, processorId: selectedProcessor })
            .then((response) => { setTransactionsNumber(response.data.transactionCount) })
            .catch((error) => console.error('Error fetching transactions number:', error));


        setStatusLoader(true)
        apiService.getTransactionsStatusStatistics({ startDate, endDate, processorId: selectedProcessor })
            .then((response) => {
                const transformedData = response.data.map((item: any) => ({
                    color: getColorByStatusType(item.name),
                    name: item.name,
                    quantitativePercent: item.quantityAndQuality?.quantitativePercent || 0,
                    quantitativeValue: item.quantityAndQuality?.quantitativeValue || 0,
                    qualitativePercent: item.quantityAndQuality?.qualitativePercent || 0,
                    qualitativeValue: item.quantityAndQuality?.qualitativeValue || 0,
                }));
                setTransactionsStatus(transformedData);
            })
            .catch((error) => console.error('Error fetching transactions status:', error))
            .finally(() => setStatusLoader(false))

        setTransactionsChartLoader(true)
        apiService.getChartTransactionsData({processorId: selectedProcessor })
            .then((response) => {
                const transactionChartData: StatisticLineChartData[] = transformTransactionsToChartLineData(response.data);
                setTransactionsChartStatus(transactionChartData);
            })
            .catch((error) => console.error('Error fetching transactions chart status:', error))
            .finally(() => setTransactionsChartLoader(false))

        setCardsLoader(true)
        apiService.getCardTypeStatistics({ startDate, endDate, processorId: selectedProcessor })
            .then((response) => {
                const transformedData = response.data.map((item: any) => ({
                    color: getColorByCardBrandType(item.name),
                    name: item.name,
                    quantitativePercent: item.quantityAndQuality?.quantitativePercent || 0,
                    quantitativeValue: item.quantityAndQuality?.quantitativeValue || 0,
                    qualitativePercent: item.quantityAndQuality?.qualitativePercent || 0,
                    qualitativeValue: item.quantityAndQuality?.qualitativeValue || 0,
                }));
                setCardTypes(transformedData);
            })
            .catch((error) => console.error('Error fetching card types:', error))
            .finally(() => setCardsLoader(false))

        setCardChartLoader(true)
        apiService.getChartCardData({processorId: selectedProcessor })
            .then((response) => {
                const cardsChartData: StatisticLineChartData[] = transformCardBrandToChartLineData(response.data);
                setCardChartTypes(cardsChartData);
            })
            .catch((error) => console.error('Error fetching card chart data:', error))
            .finally(() => setCardChartLoader(false))


        if (!isMerchant && user) {
            setMerchantsLoader(true)
            apiService.getMerchantStatistics({ startDate, endDate, processorId: selectedProcessor })
                .then((response) => {
                    const transformedData = response.data.map((item: any, index: number) => ({
                        id: item.id,
                        color: colorsPalette[index],
                        name: item.name,
                        quantitativePercent: item.quantityAndQuality?.quantitativePercent || 0,
                        quantitativeValue: item.quantityAndQuality?.quantitativeValue || 0,
                        qualitativePercent: item.quantityAndQuality?.qualitativePercent || 0,
                        qualitativeValue: item.quantityAndQuality?.qualitativeValue || 0,
                    }));
                    setMerchants(transformedData);
                })
                .catch((error) => console.error('Error fetching merchants:', error))
                .finally(() => setMerchantsLoader(false))

            setMerchantsChartLoader(true)
            apiService.getChartMerchantData({processorId: selectedProcessor })
                .then((response) => {
                    const merchantsChartData: StatisticLineChartData[] = transformToChartLineData(response.data);
                    setMerchantsChart(merchantsChartData);
                })
                .catch((error) => console.error('Error fetching merchant chart data:', error))
                .finally(() => setMerchantsChartLoader(false))
        }
    }, [user?.id, startDate, endDate, selectedProcessor]);

    const handleMerchantNavigate = (id: string) => {
        navigate(`/app/merchants/merchant/${id}`);
    }


    const handleDataUpdate = (startDate?: string, endDate?: string) => {
        setStartDate(startDate);
        setEndDate(endDate);
    }

    return (
        <div className='reports-time-page page-content'>
            <div className="page-header flex-row flex-gap-20 flex-align-start-center flex-wrap">
                <div className='page-title'>
                    Reports Processor
                </div>
                <AppSelect
                    theme='filter'
                    options={processorsOptions}
                    value={selectedProcessor}
                    placeholder='Select Processor'
                    onChange={(value) => { setSelectedProcessor(value) }}
                />
            </div>
            <div>
                <TimeFilters transactionsNo={transactionsNumber} handleFilters={handleDataUpdate} />
            </div>
            <StatisticSection title='Status Statistics'>
                <StatisticsSectionChartType data={transactionsStatus || []} isLoading={statusLoader} />
                <StatisticsSectionLineChart data={transactionsChartStatus || []} isLoading={transactionsChartLoader} />
            </StatisticSection>
            <StatisticSection title='Card Brand Statistics'>
                <StatisticsSectionChartType data={cardTypes || []} isLoading={cardsLoader} />
                <StatisticsSectionLineChart data={cardChartTypes || []} isLoading={cardChartLoader} />
            </StatisticSection>
            {!isMerchant &&
                <StatisticSection title='Merchants Statistics'>
                    <StatisticsSectionBarChartType data={merchants || []} onNavigate={handleMerchantNavigate} isLoading={merchantsLoader} />
                    <StatisticsSectionLineChart data={merchantsChart || []} isLoading={merchantsChartLoader} />
                </StatisticSection>
            }
        </div>
    )
}

export default ReportsProcessorPage